import { FolderApi, DocumentApi } from '../../test-api/index.ts'
import Toast from '@/frontapp/mixins/actions/Toast'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import { $t } from 'nette-base-module/js/vuei18next'
import handleApiError from '../../utils/handleApiError'

const folderApi = new FolderApi({}, '/api/v2')
const documentApi = new DocumentApi({}, '/api/v2')

export default async function (documentsIds, foldersIds) {
  const bcFolderStore = useBcFolderStore()
  
  if (documentsIds.length) {
    const documentHideResponse = await handleApiError(() => documentApi.documentUnhide({ ids: documentsIds }))
    documentHideResponse.data.forEach(bcFolderStore.updateDocument)
  }

  if (foldersIds.length) {
    const folderHideResponse = await handleApiError(() => folderApi.folderUnhide({ ids: foldersIds }))
    folderHideResponse.data.forEach(bcFolderStore.updateFolder)
    const unhideRecursion = (ids) => {
      ids.forEach((id) => {
        bcFolderStore.updateFolderDetail(id, 'hidden', null)
        if (bcFolderStore.listChildrenDocuments[id]) {
          bcFolderStore.listChildrenDocuments[id].forEach((doc) => { 
            bcFolderStore.updateDocumentDetail(doc.id, 'hidden', null)
          })
        }
        
        if (bcFolderStore.listChildrenFolders[id] && bcFolderStore.listChildrenFolders[id].length) {
          unhideRecursion(bcFolderStore.listChildrenFolders[id].map(e => e.id))
        }
      })
    }
    unhideRecursion(foldersIds)
  }

  const sum = documentsIds.length + foldersIds.length
  Toast(
    'success',
    sum === 1 ? $t('Item was published') : $t('%cnt% items were published', { cnt: sum })
  )
}